import React from "react";
import classnames from "classnames";
import styles from "./StatusBadge.module.scss";

export type StatusBadgeVariant = "pending" | "active" | "inactive";

interface Props {
  variant: StatusBadgeVariant;
  label?: string;
  className?: string;
}

const DEFAULT_LABELS: Record<StatusBadgeVariant, string> = {
  pending: "Pending",
  active: "Active",
  inactive: "Inactive",
};

export default function StatusBadge({
  variant,
  label,
  className,
}: Props): React.JSX.Element {
  return (
    <span
      className={classnames(styles.badge, styles[variant], className)}
      data-testid={`status-badge-${variant}`}
    >
      <span className={styles.dot} aria-hidden />
      {label ?? DEFAULT_LABELS[variant]}
    </span>
  );
}
